export function setLocalStorage(name, value) {
    localStorage.setItem(name, JSON.stringify(value));
}

export function getLocalStorage(name) {
    return JSON.parse(localStorage.getItem(name));
}

export function removeLocalStorage(items) {
    for (const i of items) {
        localStorage.removeItem(i);
    }
}
